import React from "react";
import { History } from "lucide-react";
import { formatPeso, cn } from "../../lib/utils";
import { nActions } from "../../lib/opportunityApi";

const php = (v) => formatPeso(Math.abs(v), { compact: true });
const signed = (v) => `${v > 0 ? "+" : v < 0 ? "−" : ""}${php(v)}`;
const tone = (v) => (v > 0 ? "text-success" : v < 0 ? "text-critical" : "text-muted");
const when = (iso) => (iso ? new Date(iso).toLocaleString("en-PH", { dateStyle: "medium", timeStyle: "short" }) : "—");

function Movers({ title, rows, testid }) {
  return (
    <div className="min-w-0">
      <div className="kpi-label text-[10px] mb-1.5">{title}</div>
      {rows.length ? (
        <ul className="space-y-1" data-testid={testid}>
          {rows.map(r => (
            <li key={r.engine || r.code} className="flex items-baseline justify-between gap-2 text-[12px]">
              <span className="truncate">{r.label || r.name}</span>
              <span className="font-mono-tabular shrink-0"><span className="text-muted">{php(r.before)} → {php(r.now)}</span> <span className={cn("font-semibold", tone(r.delta))}>{signed(r.delta)}</span></span>
            </li>
          ))}
        </ul>
      ) : <p className="text-[12px] text-muted" data-testid={`${testid}-none`}>No change.</p>}
    </div>
  );
}

// Change since the previous daily cycle: total, actions added or dropped, and the engines and branches that moved.
export function OpportunityChange({ change }) {
  return (
    <section data-testid="opp-change" className="space-y-3">
      <h3 className="font-display text-[15px] font-semibold tracking-tight">Change since the last cycle</h3>
      {!change.available ? (
        <p data-testid="opp-change-none" className="text-[12.5px] text-muted inline-flex items-start gap-2"><History size={13} className="mt-0.5 shrink-0" />
          No earlier cycle is recorded yet. The comparison starts with the next daily cycle.</p>
      ) : (
        <>
          <div className="text-[12.5px] leading-relaxed" data-testid="opp-change-total">
            Previous cycle · {when(change.previous_cycle_at)}: {php(change.total_before)} → <strong>{php(change.total_now)}</strong>{" "}
            <span className={cn("font-semibold", tone(change.delta))}>{signed(change.delta)} ({change.delta_pct > 0 ? "+" : ""}{change.delta_pct}%)</span>.{" "}
            {nActions(change.new_actions.count)} new ({php(change.new_actions.value)}), {nActions(change.dropped_actions.count)} dropped ({php(change.dropped_actions.value)}).
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <Movers title="Engines" rows={change.engines.filter(e => e.delta)} testid="opp-change-engines" />
            <Movers title="Branches that moved most" rows={change.branches} testid="opp-change-branches" />
          </div>
        </>
      )}
    </section>
  );
}
